import { Pipe, PipeTransform } from '@angular/core';
import { EventType, EventTypeEnum, PublicHoliday } from '../types';

const danishDisplayNames = {
  [PublicHoliday.NewYearsDay]: 'Nytårsdag',
  [PublicHoliday.MaundyThursday]: 'Skærtorsdag',
  [PublicHoliday.GoodFriday]: 'Langfredag',
  [PublicHoliday.EasterSunday]: 'Påskedag',
  [PublicHoliday.EasterMonday]: 'Anden påskedag',
  [PublicHoliday.AscensionDay]: 'Kristi himmelfartsdag',
  [PublicHoliday.PentecostSunday]: 'Pinsedag',
  [PublicHoliday.PentecostMonday]: 'Anden pinsedag',
  [PublicHoliday.ConstitutionDay]: 'Grundlovsdag',
  [PublicHoliday.ChristmasDay]: 'Juledag',
  [PublicHoliday.ChristmasEve]: 'Juleaftensdag',
  [PublicHoliday.SecondDayOfChristmas]: 'Anden juledag',
  [PublicHoliday.NewYearsEve]: 'Nytårsaftensdag',
};

@Pipe({
  name: 'publicHolidaysDisplayName',
  standalone: true,
})
export class PublicHolidayDisplayNamePipe implements PipeTransform {
  transform(value: PublicHoliday, language: 'da' = 'da'): string {
    if (language == 'da' && danishDisplayNames[value]) {
      return danishDisplayNames[value];
    }
    return value.toString();
  }
}
